import { AppConfigurationsModel } from "../models/appConfigurations.model";
import { BehaviorSubject, Observable, throwError } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { InfraService } from "./infra.service";
import { Injectable } from "@angular/core";
import { MasterLanguage } from "../models/MasterLanguage.model";
import { map } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class AppConfigurationService {
  private configValue: any;
  public configDetails;
  public configData;
  private appConfig: any = new Array(AppConfigurationsModel);

  public appConfigurationSubject: BehaviorSubject<any> =
    new BehaviorSubject<any>(this.appConfig);
  public appConfigutations$: Observable<AppConfigurationsModel[]> =
    this.appConfigurationSubject.asObservable();

  private configUrl: string;
  constructor(private infraService: InfraService, private http: HttpClient) {
    this.infraService.infraDetails$.subscribe((data) => {
      this.configUrl = data.WebEndPoint2 + "AppConfigurations";
    });
  }

  public initialConfigLoading(): Observable<any> {
    this.configData = this.http.get<any>(
      `${this.configUrl}/GetAppConfigurations`
    );
    this.appConfigurationSubject.next(this.configData);
    return this.configData;
  }

  public GetConfigValueByKey(KeyName: string) {
    this.appConfigutations$.subscribe((data) => {
      if (data.length > 0) {
        this.configDetails = data?.filter((m) => m.keyName == KeyName);
        this.configValue =
          this.configDetails != null && this.configDetails.length > 0
            ? this.configDetails[0].isEnabled
            : false;
      }
    });
    return this.configValue;
  }

  private handleError(error: Response) {
    return throwError(()=> error);
  }
}
